import React from 'react'

const Section = ({ heading, explaination }) => {

    return (
        <section className="section">
            
                <h2>{heading} </h2>
                <p>{explaination}</p>
           
        </section>
    )
}

export default Section
